import React, { useMemo } from 'react';

const Matches = React.memo(({ matches = [] }) => {
  // Use matches prop directly - parent (App.js) manages state and updates via WebSocket

  const formatPrice = (price) => {
    return typeof price === 'number' ? price.toFixed(2) : '—';
  };

  const formatQuantity = (qty) => {
    return typeof qty === 'number' ? qty.toFixed(2) : '—';
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '—';
    try {
      return new Date(timestamp).toLocaleTimeString();
    } catch {
      return '—';
    }
  };

  // Memoize the matches display to prevent unnecessary re-renders
  // Show only first 50 matches for performance
  const matchesDisplay = useMemo(() => {
    if (!matches || matches.length === 0) return null;
    
    const displayMatches = matches.slice(0, 50);
    
    return displayMatches.map((match, index) => (
      <tr key={match.match_id || match.timestamp || index} style={{borderBottom: '1px solid var(--border)'}}>
        <td style={{padding: '8px 12px', color: 'var(--muted)', fontSize: '12px'}}>
          {formatTime(match.timestamp || match.execution_timestamp || match.time)}
        </td>
        <td style={{padding: '8px 12px', color: 'var(--good)', fontWeight: '500'}}>
          {match.buyer_id || match.buy_user_id || '—'}
        </td>
        <td style={{padding: '8px 12px', color: 'var(--bad)', fontWeight: '500'}}>
          {match.seller_id || match.sell_user_id || '—'}
        </td>
        <td style={{padding: '8px 12px', textAlign: 'right', fontWeight: '500'}}>
          {formatQuantity(match.quantity || match.volume || match.executed_quantity)}
        </td>
        <td style={{padding: '8px 12px', textAlign: 'right', color: 'var(--accent)', fontWeight: 'bold'}}>
          {formatPrice(match.price || match.execution_price)}
        </td>
      </tr>
    ));
  }, [matches]);

  return (
    <div style={{maxHeight: '300px', overflowY: 'auto'}}>
      {matches && matches.length > 0 ? (
        <table className="matches-table" style={{width: '100%', borderCollapse: 'collapse', fontSize: '13px'}}>
          <thead>
            <tr style={{background: 'var(--panel)', borderBottom: '1px solid var(--border)'}}>
              <th style={{padding: '8px 12px', textAlign: 'left', fontWeight: '500', color: 'var(--muted)'}}>Time</th>
              <th style={{padding: '8px 12px', textAlign: 'left', fontWeight: '500', color: 'var(--muted)'}}>Buyer</th>
              <th style={{padding: '8px 12px', textAlign: 'left', fontWeight: '500', color: 'var(--muted)'}}>Seller</th>
              <th style={{padding: '8px 12px', textAlign: 'right', fontWeight: '500', color: 'var(--muted)'}}>Qty</th>
              <th style={{padding: '8px 12px', textAlign: 'right', fontWeight: '500', color: 'var(--muted)'}}>Price</th>
            </tr>
          </thead>
          <tbody>
            {matchesDisplay}
          </tbody>
        </table>
      ) : (
        <div style={{textAlign: 'center', color: 'var(--muted)', padding: '20px'}}>
          No recent matches
        </div>
      )}
    </div>
  );
});

Matches.displayName = 'Matches';

export default Matches;